/**import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App)
app.mount('#app')

console.log('BACK OFFICE Vue montata correttamente!')*/
import {
    createApp
} from 'vue'
import App from './App.vue'

import {
  createWebHistory,
  createRouter
} from 'vue-router'


import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, BarChart } from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'

import VChart from 'vue-echarts'

// Import Bootstrap and its styles
import 'bootstrap/dist/css/bootstrap.min.css'
import * as bootstrap from 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'
import {createAuthService, createApi} from './services/api'
import QuestionsView from './components/views/questions/QuestionsView.vue'
import QuestionView from './components/views/questions/QuestionView.vue'
import QuestionDetailView from './components/views/questions/QuestionDetailView.vue'
import QuestionDetailExpertView from './components/views/questions/QuestionDetailExpertView.vue'
import ArticleView from './components/views/ArticleView.vue'
import ArticlesView from './components/views/ArticlesView.vue'
import ElencoDownloadView from './components/views/ElencoDownloadView.vue'



use([
  CanvasRenderer,
  LineChart,
  BarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent
])


// Make bootstrap available globally
window.bootstrap = bootstrap

const response = await fetch(`${import.meta.env.VITE_BASE_URL}config.json?v=${Date.now()}`);
const config = await response.json();
const api = createApi(config.VUE_APP_API_URL)

/** configurazione router - inizio*/

const routes = [
   { path: '/questions/question/:id', name: 'questionsexpertdetail', component: QuestionDetailExpertView },
  { path: '/questions/:id', name: 'questionsdetail', component: QuestionDetailView, props: true },
  { path: '/questions', name: 'questions.list', component: QuestionsView },
  { path: '/questions/new', name: 'questions.new', component: QuestionView },
  { path: '/article/:article/:version?', name: 'article', component: QuestionDetailExpertView, props: true },
  { path: '/index.html', component: QuestionDetailExpertView },
  { path: '/downloads', name: 'downloads.list', component: ElencoDownloadView },
]

const router = createRouter({
  history: createWebHistory(config.VUE_APP_BASE_PATH),
  routes,
  scrollBehavior(to, from, savedPosition) {
      return new Promise((resolve) => {
          setTimeout(() => {
              if (savedPosition) {
                  resolve(savedPosition);
              } else {
                  resolve({
                      top: 0,
                      left: 0
                  });
              }
          }, 100);
      });
  }
})


router.afterEach(() => {
  const meta = document.createElement("meta");
  meta.httpEquiv = "Cache-Control";
  meta.content = "no-cache, no-store, must-revalidate";
  document.head.appendChild(meta);
});

/** configurazione router - fine*/

const app = createApp(App)
app.component('VChart', VChart)
app.config.globalProperties.$config = config
app.config.globalProperties.$api = api
app.config.globalProperties.$authService = createAuthService(api)
app.use(router)
app.mount('#app')